module.exports = __webpack_public_path__ + "icomoon.cb80e.woff2";